import React, { useState, useEffect } from "react";
import Menu from "./Menu/Menu";
import 'bootstrap/dist/css/bootstrap.min.css';
import Cookies from "js-cookie";
import { Route, Routes } from "react-router-dom";
import './App.css';
import Home from "./Home/Home";
import Footer from "./Footer/Footer";
import Error from "./Error";
import ContactUs from "./OtherPages/ContactUs";
import Category from "./Category/Category";
import VerticalAd from "./Ads/VerticalAd";
import Article from "./Article/Article";
import { FirebaseToken } from "./Notification/FirebaseToken";
import { getToken } from "firebase/messaging";
import YoutubeVIdeosCategory from "./Category/YoutubeVIdeosCategory";
import AmpStoriesCard from "./AmpStories/AmpStoriesCard";
import { HelmetProvider } from "react-helmet-async";
import OtherPages from "./OtherPages/OtherPages";

function App() {
  if (!Cookies.get('lg')) {
    Cookies.set('lg', 'en');
  }

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [ipaddress, setIPAddress] = useState();



  const fetchData = async () => {
    const response = await fetch("https://mobilemasala.com:9093/" + Cookies.get('lg') + "?ip=" + ipaddress, {
      method: 'POST'
    })
    const finaldata = await response.json()
    setData(finaldata.data)
    setIsLoading(false);
    Cookies.set('lg', finaldata.data.companydata.language);
    if (finaldata.data.companydata.language == 'en') {
      document.body.classList.add('en');
      document.body.classList.remove('te');
      document.body.classList.remove('hi');
    } else if (finaldata.data.companydata.language == 'tl') {
      document.body.classList.add('te');
      document.body.classList.remove('en');
      document.body.classList.remove('hi');
    } else {
      document.body.classList.remove('te');
      document.body.classList.remove('en');
      document.body.classList.add('hi');
    }
  }

  useEffect(() => {
    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => setIPAddress(data.ip))
      .catch(error => console.log(error))
    fetchData();
    // requestPermission();
  }, [])

  async function requestPermission() {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(FirebaseToken);
    } else if (permission === "denied") {
      alert("You denied for the notification");
    }
  }

  if (isLoading) {
    return <div></div>;
  }

  if (!data.companydata) {
    return "no data found."
  }
  const { companydata, navdata, otherpages } = data;
  return (
    <>
      <HelmetProvider>
        <Menu navbardata={navdata} companydetails={companydata} />
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/search/:searchdata" element={<Category />} />
          <Route path="/सर्च/:searchdata" element={<Category />} />
          <Route path="/సెర్చ్/:searchdata" element={<Category />} />

          <Route path="/:categoryname" element={<Category />} />
          <Route path="/:categoryname/:articlename" element={<Article />} />

          {/* category youtube videos */}
          <Route path="/videos" exact={true} element={<YoutubeVIdeosCategory />} />
          <Route path="/वीडियोस" exact={true} element={<YoutubeVIdeosCategory />} />
          <Route path="/వీడియోస్" exact={true} element={<YoutubeVIdeosCategory />} />
          <Route path="/RJ-Suneetha-కబుర్లు" exact={true} element={<YoutubeVIdeosCategory />} />

          <Route path="/paparazzi" exact={true} element={<YoutubeVIdeosCategory />} />
          <Route path="/पेप्पराज़ी" exact={true} element={<YoutubeVIdeosCategory />} />
          <Route path="/ఫిల్మ్-ఈవెంట్స్" exact={true} element={<YoutubeVIdeosCategory />} />

          <Route path="/trailers" exact={true} element={<YoutubeVIdeosCategory />} />
          <Route path="/ट्रेलर" exact={true} element={<YoutubeVIdeosCategory />} />
          <Route path="/ట్రైలర్స్" exact={true} element={<YoutubeVIdeosCategory />} />
          {/* category youtube videos */}

          {/* artical visual Stories */}
          <Route path="/photo-stories/:storiename" exact={true} element={<AmpStoriesCard />} />
          <Route path="/फोटो-स्टोरी/:storiename" exact={true} element={<AmpStoriesCard />} />
          <Route path="/వెబ్-స్టోరీ/:storiename" exact={true} element={<AmpStoriesCard />} />

          <Route path="/horoscope/:storiename" exact={true} element={<AmpStoriesCard />} />
          <Route path="/राशीफल/:storiename" exact={true} element={<AmpStoriesCard />} />
          <Route path="/రాశిఫలాలు/:storiename" exact={true} element={<AmpStoriesCard />} />
          {/* artical visual Stories */}

          <Route path="/contact-us" exact={true} element={<ContactUs />} />
          <Route path="/accessibility-statement" exact={true} element={<OtherPages title={"Accessibility Statement"} data={otherpages.accessibilitystatementpage} />} />
          <Route path="/privacy-policy" exact={true} element={<OtherPages data={otherpages.privacypolicypage} title={"Privacy Policy"} />} />
          <Route path="/terms-of-use" exact={true} element={<OtherPages data={otherpages.termsandconditionspage} title={"Terms of Use"} />} />
          <Route path="/disclosures" exact={true} element={<OtherPages data={otherpages.disclosurespage} title={"Disclosures"} />} />
          <Route path="*" element={<Error />} />
        </Routes>
        <Footer companydetails={companydata} />
      </HelmetProvider>
    </>
  )
}

export default App;
